import { Icon } from '@vds/icons'
import { TileContainer } from '@vds/tiles'
import { Body, Title } from '@vds/typography'
import React, { useEffect, useState } from 'react'
import { ListItem, UnorderedList } from '@vds/lists';
import { TextLink } from '@vds/buttons'
import { useSelector } from 'react-redux'
import DOMPurify from 'dompurify';
import './CoursePreview.scss'

const CoursePreview = ({setIschinese , Ischinese , coursePreviewCardData }) => {
  let type = '';
  let removeType='';
  let topicsIncluded=[];
  let allTopicsData=[];
  let sectionOne='';
  let sectionTwo='';
  let allTopicsObj={};
  let lng = localStorage.getItem("lng") ?? 'en';
  const courseCxAemData = useSelector((state) => state?.Aem?.courseCxJsonData);
  const currentCourse = useSelector((state) => state?.Aem?.currentCourse) ?? null;


  courseCxAemData?.allTopics?.allTopicsData?.map((item)=>{
    allTopicsData.push(item?.value?.toLowerCase().split(' ').join(''));
    allTopicsObj[item?.value?.toLowerCase().split(' ').join('')] =item;
  });


  useEffect(()=>{
    localStorage.removeItem('Ischinese');
  },[]);
    if(currentCourse?.tags?.indexOf('Standard Course') != -1) {
      type = "Standardcourse";
      removeType='Minicourse';
    } else if (currentCourse?.tags?.indexOf('Mini Course') != -1) {
      type = "Minicourse";
       removeType='Standardcourse';
    }
  function convertQuotedHtmlToPlain(quotedHtml, CN_link) {
    // Remove the quotes, unescape characters, and clear href value
    const userHtml = quotedHtml
    .replace(/^"/, '') // Remove starting quote
    .replace(/"$/, '') // Remove ending quote
    .replace(/\\"/g, '"') // Unescape double quotes
    .replace(/\n/g, '') // Remove actual newline character
    .replace(/href="[^"]*"/g, ( CN_link ? `href=''` : `href="/es/course-details/${currentCourse.id}"`)) // Replace href value
    .replace(/^<p>(.*?)<\/p>$/, '$1'); // Remove outer <p> tags
    const sanitizedHtml = DOMPurify.sanitize(userHtml);
    const handleContentClick= (e)=>{
      e.preventDefault();
     if(currentCourse?.locale?.includes("zh-CN") && !Ischinese){
        localStorage.setItem('Ischinese', true);
        setIschinese(true);
      }else{
        localStorage.setItem('Ischinese', false);
        setIschinese(false);
      }
    }
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizedHtml,
        }}
        {...(CN_link && { onClick: handleContentClick })}
      />
    );

  }
  // let aemData=[];

currentCourse?.localizeData?.map((item)=>{
  if(item?.locale=='en-US' && lng=='en'){
    sectionOne=item?.previewData?.[0]?.sectionOne;
    sectionTwo=item?.previewData?.[0]?.sectionTwo;
          
  }else if(item?.locale=="es-ES" && lng=='es'){
    sectionOne=item?.previewData?.[0]?.sectionOne;
    sectionTwo=item?.previewData?.[0]?.sectionTwo;
    
  }
 });
 const cardData=courseCxAemData?.overview?.filter((item)=> {
  if((item?.key==='Standardcourse' || item?.key==='Minicourse') && removeType==''){
    return false;
  }else if(item?.key!=='topics' && item?.key!==removeType){
    return true;
  }else if(item?.key==='topics'){
    topicsIncluded.push(item);
  }
});
  // const visibleCards = cardData?.filter(
  //   card => !(card?.key === "Languagesupported" && !(currentCourse?.locale?.includes("es-ES") || currentCourse?.locale?.includes("zh-CN")))
  // );
  const visibleCards = cardData?.filter(card => {

    const isLanguageCard = card?.key === "Languagesupported";
    const localeIsSupported = currentCourse?.locale?.includes("es-ES") || currentCourse?.locale?.includes("zh-CN");
    if (isLanguageCard && !localeIsSupported) {
      return false;
    }
    if (card?.key === 'ideal') {
  
      if (!sectionOne) {
        return false;
      }
    }
  
    if (card?.key === 'tools') {
      if (!sectionTwo) {
        return false;
      }
    }
    return true;
  });
  const cardCount = visibleCards?.length;
  const gridClass =
    cardCount === 4
      ? "coursePreviewContainer four-cards"
      : cardCount === 3
        ? "coursePreviewContainer three-cards"
        : "coursePreviewContainer";

  return (
    <>
      <div className={gridClass}>
        {visibleCards?.map((card, idx) => ((
            <div
              className={
                cardCount === 3 && idx === 2
                  ? "course_card_tile course_card_tile--fullspan"
                  : "course_card_tile"
              }
              key={card?.key || idx}
            >
              <TileContainer
                className="tileContainer"
                padding="24px"
                aspectRatio="none"
                width="100%"
                height="100%"
                showDropShadow="true"
                backgroundColor="#fff"
              >
                <div className='n-displayFlex'>
                <div><Icon name={card?.icon} size='XLarge' /></div>
                <div className='ml-3X'>
                  <Title size='small' bold={true}>{card?.title}</Title>
                  <TextLink type="standAlone" size="medium" tabIndex={-1} >
                  <div className='mt-2X'>
                  {card?.key === "Languagesupported" ? (
                      <UnorderedList>
                        {(currentCourse?.locale?.includes("es-ES") && lng==='en') && <ListItem size="bodyMedium" surface="light" spacing="compact">
                              {convertQuotedHtmlToPlain(card?.descriptionone,false)} 
                        </ListItem>}
                        
                       { currentCourse?.locale?.includes("zh-CN") && <ListItem size="bodyMedium" surface="light" spacing="compact">
                           { convertQuotedHtmlToPlain(card?.descriptiontwo,true)}
                        </ListItem>}    
                      </UnorderedList>
                    ) : ( (
                      card?.key==="tools" ? (   <Body>  { <div dangerouslySetInnerHTML={{ __html: sectionTwo }} /> } </Body>  ) : (
                        <Body size="Medium">{ card?.key==="ideal" ?  <div dangerouslySetInnerHTML={{ __html: sectionOne}} /> : convertQuotedHtmlToPlain(card?.descriptionone, false) }</Body>
                      )
                    )  ) }
                  </div>
                  </TextLink>
                </div>
              </div>
            </TileContainer>
          </div>
          )
        ))}
      </div>
      { currentCourse?.tags && <div className="mt-8X course_preview_topic_card">
      <TileContainer
          padding='24px'
          aspectRatio='none'
          width='100%'
          height='100%'
          showDropShadow='true'
          backgroundColor='#fff'>
          <div className='n-displayFlex'>
            <div><Icon name={topicsIncluded?.[0]?.icon} size='XLarge' /></div>
            <div className='ml-3X'>
              <Title size='small' bold={true}>{topicsIncluded?.[0]?.title}</Title>
              <TextLink type="standAlone" size="medium" tabIndex={-1} >
              <div className="mt-4X course_preview_tag_container">
                {currentCourse?.tags?.map((tag, index) => {
                  if(allTopicsData?.includes(tag.toLowerCase().split(' ').join(''))){
                    const isNonClickable= allTopicsObj?.[tag.toLowerCase().split(' ').join('')]?.noResultsPage =='true' ? true : false;
                    const divStyle = { cursor: isNonClickable ? 'default' : 'pointer'  };

                    return <div className="course_preview_tag" style={divStyle} onClick={()=>{
                      if(allTopicsObj?.[tag.toLowerCase().split(' ').join('')]?.noResultsPage !='true'){
                         document.location.href= (lng=='en' ? `/results/${tag.toLowerCase().split(' ').join('')}` : `/es/results/${tag.toLowerCase().split(' ').join('')}` );
                      }
                    }} key={index}>{allTopicsObj?.[tag.toLowerCase().split(' ').join('')]?.label}</div>
                  }
                })}
              </div>
              </TextLink>
            </div>
          </div>
        </TileContainer>
      </div> }
          </>
  )
}

export default CoursePreview